export default {
  id: 'acbc78d90f',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=mRS><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>mRS</div></div></div><div class=page-content><div class="block block-strong no-hairlines-md margin-top-half"><p><b>Modified Rankin Scale:</b></p><dl><dt>0 = No Symptoms</dt><dd>No symptoms at all</dd><dt>1 = No significant disability</dt><dd>Able to carry out all usual activities, despite some symptoms</dd><dt>2 = Slight disability</dt><dd>Able to look after own affairs without assistance, but unable to carry out all previous activities</dd><dt>3 = Moderate disability</dt><dd>Requires some help, but able to walk unassisted</dd><dt>4 = Moderately severe disability</dt><dd>Unable to attend to own bodily needs without assistance, and unable to walk unassisted</dd><dt>5 = Severe disability</dt><dd>Requires constant nursing care and attention, bedridden, incontinent</dd><dt>6 = Death</dt></dl></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};